


























































import { Component, Mixins } from 'vue-property-decorator';
import {
    YSlideshow,
    YIcon,
} from '@components/index';
import Slideshow from '@rogues/Slideshow/shared/slideshow';

@Component({
    components: {
        YSlideshow,
        YIcon,
    },
})
/**
 * @name Simple
 */
export default class Simple extends Mixins(Slideshow) {
    marginSide = 10;

    /**
     * @inheritdoc
     */
    mounted() {
        if (this.nav === 10) {
            this.marginSide = this.$el.querySelector('.slideshow-pagination')?.clientWidth + (this.$el.querySelector('.slideshow-pagination')?.clientWidth / 2);
        }
    }
}
